export const VERSION = '6.34.0'; // x-release-please-version
